<template>
  <div>
    <div class="mb-4 text-subtitle-2">
      <span class="secondary-font font-weight-bold">{{
        $t("cga.manager.title")
      }}</span>
    </div>
    <v-card class="elevation-0" color="rgba(255,255,255,0)">
      <v-card-actions class="px-0 mb-2">
        <v-btn
          depressed
          @click="refreshItems()"
          :disabled="loading.filter"
          color="grey lighten-2"
          :loading="loading.refresh"
          class="mr-2"
        >
          <v-icon left>mdi-refresh</v-icon>
          {{ $t("btn.refresh") }}
        </v-btn>
        <v-btn
          @click="getFilter()"
          depressed
          :loading="loading.filter"
          color="grey lighten-2"
          class="mr-2"
        >
          <v-icon left>mdi-filter-variant</v-icon>
          {{ $t("btn.filter") }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" @click="addCga()" color="primary">
              <v-icon left>mdi-plus</v-icon>
              {{ $t("btn.add") }}
            </v-btn>
          </template>
          <span>{{ $t("cga.manager.btn.add") }}</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
    <v-card class="elevation-1">
      <v-card-title>
        <span class="text-body-1">
          <span class="secondary-font font-weight-bold">{{
            $t("cga.manager.list.title")
          }}</span>
        </span>
      </v-card-title>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :items="items"
        :server-items-length="meta.total"
        :loading="loading.list"
        :items-per-page="itemPerPage"
        :options.sync="pagination"
        :sort-by="sortBy"
        :sort-desc="sortDesc"
        :footer-props="footerProps"
      >
        <template v-slot:body="{ items }" v-if="!_.isEmpty(items)">
          <tbody>
            <template v-for="item in items">
              <v-hover :key="item.id" v-slot:default="{ hover }">
                <tr>
                  <td style="min-width: 160px">
                    {{ $moment(item.created).format("YYYY-MM-DD HH:mm:ss") }}
                  </td>
                  <td>
                    {{ item.identifier }}
                  </td>
                  <td>
                    {{ item.username }}
                  </td>
                  <td class="text-right">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="editCga(item)"
                          x-small
                          icon
                          v-bind="attrs"
                          v-on="on"
                          v-show="hover || $vuetify.breakpoint.mdAndDown"
                          class="mr-2"
                        >
                          <v-icon color="primary">mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("btn.edit") }}</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="deleteCga(item)"
                          x-small
                          icon
                          v-bind="attrs"
                          v-on="on"
                          v-show="hover || $vuetify.breakpoint.mdAndDown"
                        >
                          <v-icon color="primary">mdi-delete-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("btn.delete") }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </v-hover>
            </template>
          </tbody>
        </template>
      </v-data-table>
      <cga-form
        :cga="cga"
        @success="refreshItems"
        :dialog="dialog.form"
      ></cga-form>
      <cga-filter @filter="applyFilter" :dialog="dialog.filter"></cga-filter>
      <cga-delete-confirm
        @confirm="confirmDeleteCga()"
        :dialog="dialog.delete"
      ></cga-delete-confirm>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import CgaDeleteConfirm from "./../../common/confirm.vue";
import CgaFilter from "./filter.vue";
import ListMixin from "./../../../mixins/commons/list";
import CgaForm from "./form.vue";
export default {
  data: () => ({
    url_items: "/api/cga-manager",
    headers: [],
    action: 1,
    dialog: {
      form: {
        display: false,
      },
      filter: {
        display: false,
      },
      delete: {
        display: false,
        title: null,
      },
    },
    cga: {},
  }),
  mixins: [ListMixin],
  methods: {
    setHeaders() {
      let headers = [];

      headers = [
        {
          text: this.$t("commons.fields.created.title"),
          align: "start",
          sortable: true,
          value: "created",
          width: 160,
        },
        {
          text: this.$t("commons.fields.identifier.title"),
          align: "start",
          value: "identifier",
          width: 130,
        },
        {
          text: this.$t("commons.fields.username.title"),
          align: "start",
          value: "username",
          width: 170,
        },
        {
          text: "",
          align: "end",
          sortable: false,
          value: null,
        },
      ];

      this.headers = headers;
    },
    addCga() {
      this.dialog.form.display = true;
      this.dialog.form.title = this.$t("cga.manager.add.title");
      this.cga = {};
    },
    editCga(cga) {
      this.dialog.form.display = true;
      this.dialog.form.title = this.$t("cga.manager.edit.title");
      this.cga = cga;
      this.action = 2;
    },
    deleteCga(cga) {
      this.cga = cga;
      this.dialog.delete.display = true;
      this.dialog.delete.title = this.$t("cga.manager.delete.title");
    },
    async confirmDeleteCga() {
      try {
        await this.request({
          url: `/api/cga-manager/${this.cga.id}`,
          method: "DELETE",
        });
        this.notify({ message: this.$t("cga.manager.delete.success") });

        this.refreshItems();
      } catch (error) {
        let err = "errors.500E";
        const status = error?.response.status;
        const content = error?.response.data;
        console.log(content);
        if (status === 422) {
          if (content.code === "P02") {
            err = "cga.manager.delete.error";
          }
        }

        this.notify({ message: this.$t(err) });
      }
    },
    getFilter() {
      this.dialog.filter.display = true;
    },
    ...mapActions({ request: "request", notify: "notification/notify" }),
  },
  components: {
    CgaForm,
    CgaFilter,
    CgaDeleteConfirm,
  },
};
</script>
